// routes/_app.profile.edit.misc.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.profile.edit.misc')

export const handle = {
  name: 'profile/edit/misc',
  track: { scene: 'profile-edit', section: 'misc' },
}

export default dynamic(getClientModule, { ssr: false })
